// import {DateTime as luxon} from 'luxon'

// import {GetBookingQueryReturnType} from '../api/booking/get-booking'
import {BookingUsageDataType, Participant} from '../api/booking/types'
// import {GetVenueQueryReturnType} from '../api/venue/get-venue'
import {PricingElementType} from '../components/pricing-details/pricing-details'
// import {FULL_CANCEL_POLICY_OPTIONS_MAP} from '../constants/cancel-policy'
import {USAGE_TYPE_SUBSCRIPTION_OPTIONS_MAP} from '../constants/usage-type'
import {TranslatorScope} from '../locale/types'
// import {CurrenciesEnum} from '../types/currencies'
import {LocaleOptions} from '../utils/i18n'
// import {isNotNilAndNotEmpty} from '../utils/logic'
// import {currDateWithTimeZone} from '../utils/time'

// const getHoursBeforeForPayOnArrival = (count: number, type: 'DAYS' | 'HOURS') => {
//   if (type === 'HOURS') {
//     return count
//   }
//   return count * 24
// }

// export const checkIfWithRequestCancel = ({
//   booking,
//   venue,
// }: {
//   booking?: GetBookingQueryReturnType
//   venue?: GetVenueQueryReturnType
// }): {
//   amountForRefund: number
//   bookingWithSubscription: boolean
//   contactToVenue: boolean
//   fee: number
//   isPastBooking: boolean
//   occupyUsage: boolean
//   cancelPolicy: string
//   currency: CurrenciesEnum
//   isPaymentOnArrival: boolean
// } | null => {
//   if (!venue || !booking) {
//     return null
//   }
//   const {
//     isPaid,
//     totalPrice,
//     paymentType,
//     participants,
//     cancelPolicy,
//     date_timestamp,
//     // paymentMethodId,
//     allowUserToCancelBooking,
//     cancelForPayOnLocationType,
//     cancelForPayOnLocationDesc,
//     cancelForPayOnLocationCount,
//   } = booking
//   const isPaymentOnArrival = !paymentType
//   const currentVenueDate = currDateWithTimeZone(venue.timeZone)
//   const hoursAmountBeforeStart = isPaymentOnArrival
//     ? getHoursBeforeForPayOnArrival(cancelForPayOnLocationCount || 0, cancelForPayOnLocationType || 'HOURS')
//     : FULL_CANCEL_POLICY_OPTIONS_MAP[cancelPolicy].hoursBeforeCancel
//   const endDateForCancel = luxon.fromMillis(Number(date_timestamp)).toUTC().minus({hours: hoursAmountBeforeStart})
//   const fitInCancelPolicy = endDateForCancel.valueOf() > currentVenueDate.valueOf()
//   const isPastBooking = currentVenueDate.valueOf() > luxon.fromMillis(Number(date_timestamp)).valueOf()
//   const bookingWithSubscription = isNotNilAndNotEmpty(participants[0]?.membershipId)
//
//   let fee = 0
//   let occupyUsage = true
//   let amountForRefund = 0
//   let contactToVenue = false
//   if (isPaymentOnArrival && !fitInCancelPolicy) {
//     contactToVenue = true
//   }
//
//   if (allowUserToCancelBooking === false) {
//     contactToVenue = true
//   } else if (isPaid) {
//     if (totalPrice == 0) {
//       if (bookingWithSubscription) {
//         occupyUsage = !fitInCancelPolicy
//       } else {
//         // just cancel
//         amountForRefund = 0
//       }
//       amountForRefund = 0
//       fee = 0
//     } else if (paymentType === 'EXSPORTIA_PAY') {
//       // if (isNilOrEmpty(paymentMethodId)) {
//       //   contactToVenue = true
//       // } else
//       if (bookingWithSubscription) {
//         occupyUsage = !fitInCancelPolicy
//         amountForRefund = fitInCancelPolicy ? totalPrice : 0
//         fee = fitInCancelPolicy ? 0 : totalPrice
//       } else {
//         amountForRefund = fitInCancelPolicy ? totalPrice : 0
//         fee = fitInCancelPolicy ? 0 : totalPrice
//       }
//     } else {
//       if (bookingWithSubscription) {
//         contactToVenue = true
//       } else {
//         if (fitInCancelPolicy) {
//           contactToVenue = true
//         } else {
//           amountForRefund = 0
//           fee = totalPrice
//         }
//       }
//     }
//   } else {
//     if (bookingWithSubscription) {
//       // cancel and credit usage
//       occupyUsage = false
//       amountForRefund = 0
//       fee = 0
//     } else {
//       // just cancel
//       amountForRefund = 0
//       fee = 0
//     }
//   }
//
//   return {
//     fee,
//     occupyUsage,
//     isPastBooking,
//     contactToVenue,
//     amountForRefund,
//     isPaymentOnArrival,
//     bookingWithSubscription,
//     currency: venue.currency,
//     cancelPolicy: isPaymentOnArrival && cancelForPayOnLocationDesc ? cancelForPayOnLocationDesc : cancelPolicy,
//   }
// }

export const getParticipantsEquipment = (participants: Participant[], calculateFullPrice = true, subLine = false) => {
  // Add-on lines (they carry an `addonId`) are shown as name x quantity at the server's `lineTotal`; the price is
  // never worked out here as price x quantity because a quantity can have its own price step.
  const addonRowIndexes = new Set<number>()
  const addonRowByAddonId = new Map<string, number>()
  const equipments: PricingElementType[] = participants.reduce<PricingElementType[]>((acc, cur) => {
    let accToSave = [...acc]
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!cur.equipments?.length) {
      return accToSave
    }
    cur.equipments.forEach((eq) => {
      if (eq.addonId) {
        const lineTotal = Number(eq.lineTotal) || 0
        const existingAddonRow = addonRowByAddonId.get(eq.addonId)
        if (existingAddonRow !== undefined) {
          accToSave[existingAddonRow] = {
            ...accToSave[existingAddonRow],
            // eslint-disable-next-line
            count: accToSave[existingAddonRow].count! + eq.quantity,
            price: accToSave[existingAddonRow].price + lineTotal,
          }
        } else {
          addonRowByAddonId.set(eq.addonId, accToSave.length)
          addonRowIndexes.add(accToSave.length)
          accToSave = [...accToSave, {subLine, text: eq.name || eq.value, count: eq.quantity, price: lineTotal}]
        }
        return
      }
      const existingIndex = accToSave.findIndex(
        (existedEq, index) => !addonRowIndexes.has(index) && existedEq.text === eq.value,
      )
      if (existingIndex !== -1) {
        accToSave[existingIndex] = {
          ...accToSave[existingIndex],
          // eslint-disable-next-line
          count: accToSave[existingIndex].count! + eq.quantity,
        }
      } else {
        accToSave = [
          ...accToSave,
          {
            subLine,
            text: eq.value,
            count: eq.quantity,
            price: eq.price,
          },
        ]
      }
    })
    return accToSave
  }, [])
  const equipmentsToReturn = equipments.map((eq, index) => {
    if (addonRowIndexes.has(index)) {
      // The line's total is already its price. Asked for a price each, give the average.
      // eslint-disable-next-line
      return calculateFullPrice ? eq : {...eq, price: Math.round((eq.price / eq.count!) * 100) / 100}
    }
    // eslint-disable-next-line
    return calculateFullPrice ? {...eq, price: eq.price * eq.count!} : eq
  })
  return equipmentsToReturn.filter((el) => el.count !== 0)
}

export const getUsageString = (
  l: (scope: TranslatorScope, options?: LocaleOptions) => string,
  usage?: BookingUsageDataType | null,
  isRefund?: boolean,
) => {
  if (!usage) {
    return null
  }
  const label = USAGE_TYPE_SUBSCRIPTION_OPTIONS_MAP[usage.amountByType] as TranslatorScope
  const usageText = `${usage.used} ${l(label)}`
  return `${usageText} ${l(isRefund ? 'refunded' : 'used', {caseAction: 'titleCase'})}`
}
